import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { ProductAttributeRow } from '../../../../core/model';

@Component({
  selector: 'py-technical-attributes-table',
  templateUrl: './technical-attributes-table.component.html',
  styleUrls: ['./technical-attributes-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TechnicalAttributesTableComponent implements OnInit {
  @Input() attributes: ProductAttributeRow[];

  @Input()
  @HostBinding('class.show-sku-picker')
  pdpTypeSkuPicker: boolean = true;

  get headerAttributes() {
    return this.attributes && this.attributes[0];
  }

  get listItems() {
    const items = [];

    this.headerAttributes?.values?.forEach((value, index) => {
      items[index] = {
        name: value,
        isoCode: this.headerAttributes.attribute.isoCode,
        values: [],
      };
    });

    this.attributes.forEach((attribute) => {
      return attribute.values.forEach((value, index) => {
        items[index].values.push({ value, attribute: attribute.attribute });
      });
    });
    return items;
  }

  constructor(public elementRef: ElementRef) {}

  ngOnInit(): void {}
}
